import { F } from './fancybox-BA187ItQ.js';

class ProductMedia extends HTMLElement {
  #mediaItems = [...this.querySelectorAll('.product-media-item')];

  async connectedCallback() {
    await this.#initSwiper();
    this.initFancybox();
  }

  async #initSwiper() {
    if (this.#mediaItems.length <= 1) return;

    try {
      const { Swiper } = await import('@services');
      const { Navigation, Pagination } = await import('./index-CtDRYH-N.js');

      new Swiper('.swiper--media', {
        modules: [Navigation, Pagination],
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          bulletElement: 'button',
        },
        loop: false,
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  initFancybox() {
    F.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }
}

customElements.define('product-media', ProductMedia);
